/*
|----------------------------------------------------------
|   WordPress:
|---------------------------------------------------------
|   All functions related to WordPress platform features.
|
*/

/**
 * Import config
 */
import config from "./config";

export default {

    /**
     * Swaps the WordPress admin bar
     * when loading a new page via pjax.
     * @param   Object  pjax    must pass the ITM.pjax object
     */
    swapWPAdminbar: function(pjax) {
        if (config.debug) console.log('swapWPAdminbar');
        var newBar = jQuery(pjax.newDocument).find('#wpadminbar')
        jQuery('#wpadminbar').html(newBar.html())

    },

    /**
     * Update all meta tags on pjax calls.
     * @param   Object  pjax    must pass the ITM.pjax object
     */
    swapMetaTagValue: function(pjax) {
        if (config.debug) console.log('swapMetaTagValue');

        //Post Title Meta
        jQuery('meta[name=post-title]').remove();
        var postTitleMeta = jQuery(pjax.newDocument).find("meta[name=post-title]");
        jQuery('meta[name=description]').after(postTitleMeta);

        //Post Category Meta
        jQuery('meta[name=post-categories]').remove();
        var postCategoryMeta = jQuery(pjax.newDocument).find("meta[name=post-categories]");
        jQuery('meta[name=post-title]').after(postCategoryMeta);

        //Post Tag Meta
        jQuery('meta[name=post-tags]').remove();
        var postTagMeta = jQuery(pjax.newDocument).find("meta[name=post-tags]");
        jQuery('meta[name=post-categories]').after(postTagMeta);

        //Post Date Meta
        jQuery('meta[name=post-date]').remove();
        var postDateMeta = jQuery(pjax.newDocument).find("meta[name=post-date]");
        jQuery('meta[name=post-tags]').after(postDateMeta);

        //Post Author Meta
        jQuery('meta[name=post-author]').remove();
        var postAuthorMeta = jQuery(pjax.newDocument).find("meta[name=post-author]");
        jQuery('meta[name=post-date]').after(postAuthorMeta);

    },

    /**
     * Update wordPress auto generated body
     * classes on pjax page loads.
     * @param   Object  pjax    must pass the ITM.pjax object
     */
    swapBodyClass: function(pjax) {
        if (config.debug) console.log('swapBodyClass');
        // var pjax = this
        var newClass = jQuery(pjax.newDocument).find('body').attr('class')

        jQuery('body').attr('class', newClass)
        jQuery('body').addClass('pjax')

    }

}
